import React, { Fragment } from 'react';
import { tickIcon2 } from './Icons';

const Stepper: React.FC<{
    items: { title: string; subTitle?: string; checked?: boolean; hideTag?: boolean }[];
    className?: string;
    innerClassName?: string;
    showTag?: boolean;
    separatorClassName?: string;
    orientation?: 'vertical' | 'horizontal';
}> = ({
    items,
    className,
    showTag = false,
    innerClassName,
    separatorClassName,
    orientation = 'horizontal',
}) => {
    return (
        <div
            className={`flex items-center justify-between ${className ?? ''} ${
                orientation === 'vertical' ? 'flex-col' : ''
            }`}
        >
            {items.map((it, idx) => (
                <Fragment>
                    <div className="flex items-center justify-between">
                        <div
                            className={`border flex justify-between items-center border-darwin-neutral_new-200 rounded-8 px-8 py-12 ${
                                innerClassName ?? ''
                            }`}
                        >
                            <div className="flex gap-8 items-center">
                                {it.checked ? (
                                    <span className="border border-darwin-green-primary flex items-center justify-center rounded-full">
                                        {tickIcon2('fill-darwin-green-primary font-700 w-18 h-18')}
                                    </span>
                                ) : (
                                    <span className="border border-darwin-neutral_new-200 flex items-center justify-center rounded-full">
                                        <span
                                            style={{ borderWidth: 0.5 }}
                                            className="border flex items-center justify-center rounded-full"
                                        >
                                            <p className="font-400 text-12 flex items-center justify-center w-18 h-18 text-12 text-darwin-neutral_new-1000">
                                                {idx + 1}
                                            </p>
                                        </span>
                                    </span>
                                )}
                                <p className="text-13">{it.title}</p>
                            </div>
                            {showTag && !it.hideTag ? (
                                it.checked ? (
                                    <div className="flex justify-center items-center rounded-8 bg-darwin-accent-green-200 px-8 py-4">
                                        <p className="font-700 text-darwin-accent-green-900 text-10">
                                            COMPLETED
                                        </p>
                                    </div>
                                ) : (
                                    <div
                                        className="flex justify-center items-center rounded-8 px-8 py-4"
                                        style={{ background: '#FBEFCE' }}
                                    >
                                        <p
                                            className="font-700 text-10"
                                            style={{ color: '#8E6807' }}
                                        >
                                            PENDING
                                        </p>
                                    </div>
                                )
                            ) : null}
                        </div>
                    </div>
                    {idx !== items.length - 1 && (
                        <span
                            style={{ borderWidth: 0.5 }}
                            className={`flex-grow border border-b ${separatorClassName ?? ''}`}
                        ></span>
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export default Stepper;
